import gql from "graphql-tag";
const field = `
id
name
code
departments {
        id
        name
      }
createdAt
updatedAt
`;

const createDepartmentGroup = gql`
  mutation(
    $code: String!
    $name: String
    $departmentIds: [ID!]
  ) {
    createDepartmentGroup(
      data: {
        code: $code
        name: $name
        departmentIds: $departmentIds
      }
    ) {
      ${field}
    }
  }
`;

const updateDepartmentGroup = gql`
  mutation(
    $id: ID!
    $code: String!
    $name: String
    $departmentIds: [ID!]
  ) {
    updateDepartmentGroup(
      id: $id
      data: {
        code: $code
        name: $name
        departmentIds: $departmentIds
      }
    ) {
      ${field}
    }
  }
`;

const deleteDepartmentGroup = gql`
  mutation($id: ID!) {
    deleteDepartmentGroup(id: $id) {
      id
    }
  }
`;

const getListDepartmentGroup = gql`
  query($limit: Int, $page: Int, $query: String) {
    getListDepartmentGroup(query: $query paging: { limit: $limit, page: $page }) {
      ${field}
      author {
        id
        username
        fullname
      }
    }
  }
`;

const getDepartmentGroup = gql`
  query($id: ID!) {
    getDepartmentGroup(id: $id) {
      ${field}
      author {
        id
        username
        fullname
      }
    }
  }
`;

const getDepartmentGroupByCode = gql`
  query($code: String!) {
    getDepartmentGroup(code: $code) {
      ${field}
    }
  }
`;

export default {
  createDepartmentGroup,
  updateDepartmentGroup,
  deleteDepartmentGroup,
  getListDepartmentGroup,
  getDepartmentGroup,
  getDepartmentGroupByCode,
};
